module.exports = [{
      plugin: require('../node_modules/gatsby-plugin-manifest/gatsby-browser.js'),
      options: {"plugins":[],"name":"NodeDev","short_name":"NodeDev","icon":"src/images/logo-node.png","start_url":"/","background_color":"#353d3e","theme_color":"#353d3e","display":"standalone"},
    },{
      plugin: require('../node_modules/gatsby-plugin-offline/gatsby-browser.js'),
      options: {"plugins":[]},
    },{
      plugin: require('../node_modules/gatsby-plugin-google-tagmanager/gatsby-browser.js'),
      options: {"plugins":[],"id":"GTM-534RD2Z","includeInDevelopment":false},
    },{
      plugin: require('../node_modules/gatsby-plugin-matomo/gatsby-browser.js'),
      options: {"plugins":[],"siteId":"7","matomoUrl":"https://analytics.nodesource.com","siteUrl":"https://nodestaging.netlify.app/","cookieDomain":"*.node.dev"},
    },{
      plugin: require('../gatsby-browser.js'),
      options: {"plugins":[]},
    }]
